// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationPromptDialog_root__3m63F"};